import {Grid, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {type ReactElement, useState} from 'react'

import {Body, TextInput, ToggleTitle} from '../../../../components/desktop'
import {useConfigContext} from '../../../../contexts'
import {Suggest} from '../Suggest/Suggest.desktop'
import type {Props} from './Address.types'

export function AddressDetails({isSource, name}: Props): ReactElement {
  const i18n = useI18n()
  const [isOpened, setIsOpened] = useState(false)
  const {location} = useConfigContext()

  return (
    <Body
      lead={
        <>
          <Typography group="tight" mt="s" thickness="medium" variant="body2">
            {i18n('cargo.create.address.address', 'Адрес')}
          </Typography>
          <ToggleTitle
            isOpened={isOpened}
            onClick={() => {
              setIsOpened(prev => !prev)
            }}
            title={i18n('cargo.create.address.details', 'Детали')}
          />
        </>
      }
      tail={
        <Grid container>
          <Grid xs={12} item>
            <Suggest coordinates={location} isSource={isSource} name={name} />
          </Grid>
          {isOpened && (
            <Grid xs={12} item>
              <Grid size="s" container>
                <Grid xs={3} item>
                  <TextInput
                    label={i18n('bdui.address.input.entrance', 'Подъезд')}
                    name={`${name}.entrance`}
                    size="l"
                    variant="line"
                  />
                </Grid>
                <Grid xs={3} item>
                  <TextInput
                    label={i18n('bdui.address.input.code', 'Домофон')}
                    name={`${name}.code`}
                    size="l"
                    variant="line"
                  />
                </Grid>
                <Grid xs={3} item>
                  <TextInput
                    label={i18n('bdui.address.input.floor', 'Этаж')}
                    name={`${name}.floor`}
                    size="l"
                    variant="line"
                  />
                </Grid>
                <Grid xs={3} item>
                  <TextInput
                    label={i18n('bdui.address.input.apartment', 'Кв./офис')}
                    name={`${name}.apartment`}
                    size="l"
                    variant="line"
                  />
                </Grid>
              </Grid>
              <Grid xs={12} item>
                <TextInput
                  label={i18n('bdui.address.input.comment', 'Комментарий для курьера')}
                  name={`${name}.comment`}
                  size="l"
                  variant="line"
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      }
    />
  )
}
